(function () {
  'use strict';

  document.querySelectorAll('[data-product-zone][data-wheel-product]').forEach(function (zone) {
    var section = zone.closest('section');
    var json = section && section.querySelector('[data-variant-json]');
    var id = zone.querySelector('[data-variant-id]');
    var gallery = zone.querySelector('[data-slides]');
    if (!json || !id || !gallery) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }
    var lastVariant = '';
    var queued = false;

    function resource(src) {
      try {
        var url = new URL(src, window.location.href);
        return url.origin + url.pathname;
      } catch (error) { return ''; }
    }

    function sync() {
      queued = false;
      if (!id.value || id.value === lastVariant) return;
      lastVariant = id.value;
      var variant = variants.find(function (entry) { return String(entry.id) === id.value; });
      // Only a native, explicitly assigned variant image changes the photo. Shared reference photos stay shared.
      var photo = variant && variant.featured_image;
      var src = typeof photo === 'string' ? photo : photo && (photo.src || photo.url);
      if (!src) return;
      var key = resource(src);
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide]'));
      var index = slides.findIndex(function (slide) { return resource(slide.getAttribute('src')) === key; });
      if (index < 0) return;
      var thumbs = zone.querySelectorAll('[data-thumb]');
      if (thumbs[index]) thumbs[index].click();
      // Move only the image row. Choosing an option never drags the buyer back up the product page.
      if (gallery.scrollTo) gallery.scrollTo({ left: index * gallery.clientWidth, behavior: 'auto' });
      else gallery.scrollLeft = index * gallery.clientWidth;
    }

    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sync);
    }

    zone.addEventListener('change', queue);
    window.addEventListener('pageshow', queue);
    queue();
  });
})();
